import { Separator } from "@/components/ui/separator";
export default function PrivacyPolicyOverview() {
  return <section id="privacy-policy-overview" className="relative bg-primary text-primary-foreground overflow-hidden pt-24 pb-16 lg:pt-32 lg:pb-24">
      {}
      <div className="absolute inset-0 opacity-5 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576388/img/naval_chart_texture.png)] bg-cover bg-center pointer-events-none mix-blend-overlay" aria-hidden="true" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {}
        <span className="block font-mono text-ring text-xl md:text-2xl mb-8 md:mb-12">
          01
        </span>

        {}
        <h1 className="font-serif font-bold text-5xl md:text-6xl lg:text-[72px] leading-tight tracking-normal mb-12 lg:mb-20">
          Privacy Policy
        </h1>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-start-7 lg:col-span-6">
            <div className="space-y-12">
              <div className="space-y-4">
                <h2 className="font-serif text-2xl font-bold text-primary-foreground">Data Controller</h2>
                <p className="font-sans text-lg text-primary-foreground/80 leading-relaxed">
                  Venchandlers Nexus is responsible for managing and protecting the personal information collected through this website.
                </p>
                <p className="font-sans text-lg text-primary-foreground/80 leading-relaxed">
                  Data Controller: Julio Rosario / Venchandlers Nexus, Location: Asturias, Spain, Contact email: operations@venchandlersnexus.com
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="font-serif text-2xl font-bold text-primary-foreground">Personal Data Collected</h2>
                <p className="font-sans text-lg text-primary-foreground/80 leading-relaxed">
                  The website may collect name, company name, email address, phone number, vessel or service request details, and supporting documents submitted voluntarily through the RFQ form.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="font-serif text-2xl font-bold text-primary-foreground">Purpose of Data Processing</h2>
                <p className="font-sans text-lg text-primary-foreground/80 leading-relaxed">
                  We use your data to respond to your inquiries, provide our services, and ensure our website functions correctly.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="font-serif text-2xl font-bold text-primary-foreground">Contact Information</h2>
                <p className="font-sans text-lg text-primary-foreground/80 leading-relaxed">
                  If you have questions about your privacy or how your data is handled, please reach out to us using the contact methods provided on our website.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <Separator className="absolute bottom-0 left-0 w-full bg-secondary" />
    </section>;
}